import React, {Component} from 'react';
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import FlatButton from "material-ui/FlatButton/index";
import ContentCreate from "material-ui/svg-icons/content/create";
import {TextInput} from "components/input";
import {List, Datagrid, FilterForm} from 'components/list';
import {TextField} from 'components/field';

import FromTimestampToDateField from 'util/fields/FromTimestampToDateField';
import {saveDataRecordSelected} from "actions/recordSelectedActions";

import * as urls from "./urls";
import * as utils from './utils';
import {ShopUnblockResourceName} from "./resources";


const ShopUnblockListFilter = (props) => (
    <FilterForm {...props} initialValues={Object.assign({}, props.defaultSearchValue, {'require_rental_status': '1'})}>
    <TextInput source="mobile_number" label="Mobile"/>
  </FilterForm>
);

function shopIsBlocked(status) {
  return (status & 0x2) === 0x2;
}

class UnblockButton extends Component {
  constructor(props) {
    super(props);
    this.saveCurrentShopData = this.saveCurrentShopData.bind(this);
  }

  saveCurrentShopData() {
    const {record} = this.props;
    this.props.dispatch(saveDataRecordSelected(ShopUnblockResourceName, record));
  }

  render() {
    const {record} = this.props;
    let is_superuser = localStorage.getItem('is_superuser');
    let action = <span />;
    if (shopIsBlocked(record['status'])) {
      if(is_superuser === 'true') {
        action = <Link to={urls.shopUnblockForceRequestFrontendPath}/>
      } else {
        action = <Link to={urls.shopUnblockRequestFrontendPath}/>
      }
    }
    // ELSE
    return (
      <div onClick={this.saveCurrentShopData}>
        <FlatButton
          primary
          label='Enable'
          disabled={!shopIsBlocked(record['status'])}
          icon={<ContentCreate/>}
          containerElement={action}
          style={{overflow: 'inherit'}}
        />
      </div>
    )
  }
}

const UnblockButtonConnected = connect()(UnblockButton);

const CustomField = (props) => {
  const { source, record } = props;
  const newRecord = {};
  if (shopIsBlocked(record[source])) {
    newRecord[source] = 'Disabled';
  } else {
    newRecord[source] = 'Enabled';
  }

  newRecord['rental_status'] = utils.generateRentalStatus(record);

  return (
    <TextField {...props} record={newRecord}/>
  );
};


class ShopUnblockList extends Component {
  render() {
    const {filterValues} = this.props;
    let autoLoadData = false;
    if (filterValues && Object.keys(filterValues).length > 0) {
      autoLoadData = true;
    }

    return (
      <List
        {...this.props}
        autoLoadData={autoLoadData}
        filters={<ShopUnblockListFilter defaultSearchValue={filterValues}/>}
      >
        <Datagrid bodyOptions={{stripedRows: true, showRowHover: true}}>
          <TextField source="shop_id" label="Shop ID"/>
          <TextField source="owner_mobile" label="Owner mobile"/>
          <TextField source="shop_name" label="Shop name"/>
          <FromTimestampToDateField source="add_time" label="Create Date"/>
          <CustomField source="rental_status" label="Rental Status"/>
          <TextField source="last_updated_by" label="Last Updated By"/>
          <CustomField source="status" label="Status"/>
          <UnblockButtonConnected label="Action"/>
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    filterValues: state.admin.filter[ShopUnblockResourceName],
    shopData: state.admin[ShopUnblockResourceName].data,
  })
)(ShopUnblockList);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopUnblockList.js